import * as React from "react";
import { IconProps } from "./types";

export const Expand02Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M3 21L21 3M3 21H9M3 21L3 15M21 3H15M21 3V9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(Expand02Icon as React.FunctionComponent).displayName = "Expand02Icon";

export default Expand02Icon;
